import {
  Notification,
  QuestionCircleFilled,
  SettingFilled,
} from 'farmhub-ui-core';
import {
  Home,
  BarChart2,
  Settings,
  Users,
  DollarSign,
  ClipboardList,
  History,
  Database,
  Ticket,
  Image as ImageIcon,
  FileText,
  Box,
  Warehouse,
  CalendarDays,
  Map,
  MapPin,
  CalendarClock,
  Store,
  User,
  Briefcase,
  CircleDollarSign,
  Trophy,
  Globe,
  MessageCircle,
  Slack,
  Route,
  SplitSquareHorizontal,
  PlusSquare,
  ShoppingCart,
  ShoppingBag,
  CheckCircle,
  XCircle,
  AlertCircle,
  Link,
  Clock,
  PackageSearch,
  BookOpen,
  PieChart,
  Truck,
  Sprout,
  Receipt,
  UserCheck,
  CreditCard,
  Target,
  Send,
  PackageOpen,
  Percent,
  Factory,
} from 'lucide-react';

import {
  updateOrderItemNote,
  updateOrderNote,
  updateProposalItemNote,
  updateTempCustomerNote,
} from 'slice';
import { COLLABORATOR_TEXT, MENU_TITLE_ORDER_BY_STATUS } from 'utils/constants';

export * from './sidebar';

export const renderEntityName = (entityType: number) => {
  switch (entityType) {
    case 1:
      return 'Nông trại';
    case 2:
      return 'Cửa hàng';
    case 3:
      return `${COLLABORATOR_TEXT.CAPITALIZE}`;
    case 4:
      return 'Kho chứa';
    case 5:
      return 'Vận chuyển';
    case 6:
      return 'Thiện nguyện';
    default:
      return '';
  }
};

export const genMenuIcon = (name: string) => {
  const iconProps = { className: 'icon', size: 22, strokeWidth: 1.5 };
  switch (name) {
    case 'Tổng quan':
      return <Map {...iconProps} />;
    case 'Thống kê':
      return <PieChart {...iconProps} />;
    case 'Trang chủ':
      return <Home {...iconProps} />;
    case 'Dự báo sản lượng':
    case 'Dự báo':
      return <Target {...iconProps} />;
    case 'Thiết lập dự báo':
      return <Settings {...iconProps} />;
    case `${COLLABORATOR_TEXT.CAPITALIZE}`:
      return <UserCheck {...iconProps} />;
    case 'Doanh thu':
    case 'Thống kê doanh thu':
    case 'Báo cáo doanh thu':
    case 'Báo cáo tài chính':
      return <DollarSign {...iconProps} />;
    case 'Quản lý đơn cộng tác':
    case 'Đơn cộng tác':
      return <Users {...iconProps} />;
    case 'Lịch sử thay đổi':
      return <History {...iconProps} />;
    case 'Đối tượng':
    case 'Nhật ký':
      return <Sprout {...iconProps} />;
    case 'Coupon của bạn':
      return <Ticket {...iconProps} />;
    case 'Banner':
      return <ImageIcon {...iconProps} />;
    case 'Giao dịch':
      return <CircleDollarSign {...iconProps} />;
    case 'Quản lý đơn bán':
      return <ShoppingCart {...iconProps} />;
    case 'Mua bán':
    case 'Tôi bán':
    case 'Lên đơn hàng':
    case 'Chốt đơn mua bán':
      return <ShoppingCart {...iconProps} />;
    case 'Tôi mua':
      return <ShoppingCart {...iconProps} />;
    case 'Chiến dịch':
    case 'Giảm giá':
    case 'Chương trình marketing':
    case 'Kênh marketing':
      return <Percent {...iconProps} />;
    case 'Mua chung':
      return <Users {...iconProps} />;
    case 'Combo':
      return <PackageOpen {...iconProps} />;
    case 'Thông báo chung':
      return <AlertCircle {...iconProps} />;
    case 'Vận đơn':
    case 'Đơn hàng bán':
    case 'Đơn hàng':
      return <ShoppingBag {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.PRE_PROCESSING:
      return <Clock {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.PENDING:
    case 'Đơn hàng chờ':
    case 'Chờ nhập hàng':
      return <Clock {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.CONFIRM:
    case MENU_TITLE_ORDER_BY_STATUS.SELF_CONFIRM:
      return <CheckCircle {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.SUPPLIER_CONFIRM:
    case MENU_TITLE_ORDER_BY_STATUS.SELF_SUPPLIER_CONFIRM:
      return <CheckCircle {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.PROCESSING:
      return <Settings {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.CUSTOMER_DRAFT:
      return <FileText {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.SUPPLIER_DRAFT:
      return <FileText {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.DELIVERY:
      return <Truck {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.REJECT:
      return <XCircle {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.COMPLETE:
      return <CheckCircle {...iconProps} />;
    case MENU_TITLE_ORDER_BY_STATUS.PENDING_EXECUTE:
      return <Clock {...iconProps} />;
    case 'Đã liên kết':
      return <Link {...iconProps} />;
    case 'Chờ phê duyệt':
      return <Clock {...iconProps} />;
    case 'Gợi ý liên kết':
      return <Send {...iconProps} />;
    case 'Chờ xác nhận':
      return <Clock {...iconProps} />;
    case 'Yêu cầu liên kết':
      return <Send {...iconProps} />;
    case 'Đơn chuỗi mua bán':
    case 'Đối tác':
    case 'Thông báo liên kết':
      return <Link {...iconProps} />;
    case 'Thành viên':
      return <Users {...iconProps} />;
    case 'Chính sách':
      return <BookOpen {...iconProps} />;
    case 'Chính sách giá bán':
      return <DollarSign {...iconProps} />;
    case 'Chính sách dự báo':
      return <Target {...iconProps} />;
    case 'Thư viện':
      return <ImageIcon {...iconProps} />;
    case 'Hình ảnh':
      return <ImageIcon {...iconProps} />;
    case 'Tập tin':
      return <FileText {...iconProps} />;
    case 'Sản phẩm':
    case 'Quản lý kho':
    case 'Thống kê sản phẩm':
    case 'Báo cáo kho':
      return <Box {...iconProps} />;
    case 'Tồn kho':
      return <Warehouse {...iconProps} />;
    case 'Vật tư':
      return <Box {...iconProps} />;
    case 'Danh mục vật tư':
      return <Box {...iconProps} />;
    case 'Kế hoạch sản xuất':
    case 'Kế hoạch':
      return <CalendarDays {...iconProps} />;
    case 'Công nhật':
      return <CalendarClock {...iconProps} />;
    case 'Công việc':
      return <CalendarClock {...iconProps} />;
    case 'Vùng sản xuất':
      return <Map {...iconProps} />;
    case 'Danh sách vùng':
      return <Map {...iconProps} />;
    case 'Đối tượng theo vùng':
      return <MapPin {...iconProps} />;
    case 'Đối tượng nuôi trồng':
      return <Sprout {...iconProps} />;
    case 'Đối tượng sản xuất':
    case 'Truy xuất nguồn gốc':
    case 'Tài nguyên':
      return <Database {...iconProps} />;
    case 'Quy trình':
      return <Settings {...iconProps} />;
    case 'Nhân viên':
    case 'Nhân sự':
      return <Users {...iconProps} />;
    case 'Nhà cung cấp':
      return <Factory {...iconProps} />;
    case 'Khách hàng':
      return <User {...iconProps} />;
    case 'Tổng quan khách hàng':
    case 'Tổng quan nhà cung cấp':
      return <PieChart {...iconProps} />;
    case 'Chi nhánh':
      return <Store {...iconProps} />;
    case 'Chi nhánh cửa hàng':
      return <Store {...iconProps} />;
    case 'Tem truy xuất':
      return <PackageSearch {...iconProps} />;
    case 'Tạo sản phẩm':
      return <PlusSquare {...iconProps} />;
    case 'Website':
    case 'Xây dựng thương hiệu':
    case 'Cá nhân thương hiệu':
    case 'Thông tin website':
    case 'Thiết kế gian hàng':
    case 'Thiết kế website':
      return <Globe {...iconProps} />;
    case 'Ứng dụng khác':
    case 'Ứng dụng mở rộng':
      return <Box {...iconProps} />;
    case 'Cài đặt mua hàng':
    case 'Thiết lập':
      return <Settings {...iconProps} />;
    case 'Kết nối Kiotviet':
      return <Settings {...iconProps} />;
    case 'Kết nối Zalo':
    case 'Thông báo Zalo':
      return <MessageCircle {...iconProps} />;
    case 'Kết nối Misa':
      return <Settings {...iconProps} />;
    case 'Tài khoản thanh toán':
      return <CreditCard {...iconProps} />;
    case 'Thông báo nội bộ':
      return <AlertCircle {...iconProps} />;
    case 'Báo cáo':
      return <BarChart2 {...iconProps} />;
    case 'Báo cáo nhận đơn':
      return <FileText {...iconProps} />;
    case 'Báo cáo cân bằng':
      return <SplitSquareHorizontal {...iconProps} />;
    case 'Tổng hợp số lượng':
    case 'Thống kê sản lượng':
    case 'Báo cáo sản lượng':
      return <BarChart2 {...iconProps} />;
    case 'Vị trí giao hàng':
      return <MapPin {...iconProps} />;
    case 'Giảm giá đơn hàng':
    case 'Chính sách giảm giá':
      return <Percent {...iconProps} />;
    case 'Phí giao hàng':
    case 'Chính sách giao hàng':
      return <Truck {...iconProps} />;
    case 'Hỗ trợ':
      return <AlertCircle {...iconProps} />;
    case 'Mô hình doanh nghiệp':
    case 'Sơ đồ phân hệ':
      return <Database {...iconProps} />;
    case 'Thông企业': // Typo in original? No, it's Thông tin doanh nghiệp
    case 'Thông tin doanh nghiệp':
    case 'Thông tin chung':
      return <Briefcase {...iconProps} />;
    case 'Thông tin kho':
    case 'Tiện ích':
      return <ClipboardList {...iconProps} />;
    case 'Liên hệ':
      return <User {...iconProps} />;
    case 'Chứng nhận':
      return <Trophy {...iconProps} />;
    case 'SEO website':
      return <Globe {...iconProps} />;
    case 'Thông báo Telegram':
      return <MessageCircle {...iconProps} />;
    case 'Thông báo Slack':
      return <Slack {...iconProps} />;
    case 'Thông tin liên hệ':
      return <ClipboardList {...iconProps} />;
    case 'Mã giảm giá':
    case 'Coupon khuyến mãi':
      return <Ticket {...iconProps} />;
    case 'Chuỗi cửa hàng':
      return <Store {...iconProps} />;
    case 'Tuyến đường':
      return <Route {...iconProps} />;
    case 'Kho chứa':
      return <Warehouse {...iconProps} />;
    case 'Chia hàng':
      return <SplitSquareHorizontal {...iconProps} />;
    case 'Bán tại kho':
      return <Store {...iconProps} />;
    case 'Bán tại quầy':
      return <Store {...iconProps} />;
    case 'Chi nhánh sản xuất':
      return <Factory {...iconProps} />;
    case 'Thông báo hệ thống':
      return <AlertCircle {...iconProps} />;
    case 'Thông báo đơn hàng':
      return <ShoppingBag {...iconProps} />;
    case 'Yêu cầu mua hàng':
      return <ShoppingCart {...iconProps} />;
    case 'Đơn mua chung':
      return <Users {...iconProps} />;
    case 'Tạo đơn hàng':
      return <PlusSquare {...iconProps} />;
    case 'Cân bằng đơn hàng':
      return <SplitSquareHorizontal {...iconProps} />;
    case 'Đặt hàng':
    case 'Quản lý đơn mua':
      return <ShoppingCart {...iconProps} />;
    case 'Thu mua':
      return <Box {...iconProps} />;
    case 'Thiết lập báo cáo':
      return <Settings {...iconProps} />;
    case 'Thiết lập đặt hàng':
      return <Settings {...iconProps} />;
    case 'Bán hàng':
    case 'Đơn hàng mua':
    case 'Đơn nhập hàng':
      return <ShoppingBag {...iconProps} />;
    case 'Vật phẩm':
      return <Box {...iconProps} />;
    case 'Kiểm kho':
      return <ClipboardList {...iconProps} />;
    case 'Danh sách giao hàng':
      return <Truck {...iconProps} />;
    case 'Liên hệ bán hàng':
      return <User {...iconProps} />;
    case 'Phân công đơn hàng':
    case 'Phân công nhập hàng':
    case 'Nhập hàng':
    case 'Xuất hàng':
    case 'Chuyển hàng':
      return <ClipboardList {...iconProps} />;
    case 'Công nợ':
    case 'Báo cáo công nợ':
      return <Receipt {...iconProps} />;
    case 'Báo cáo bán hàng':
      return <BarChart2 {...iconProps} />;
    case 'Hóa đơn':
      return <Receipt {...iconProps} />;
    case 'Đổi trả hàng':
      return <History {...iconProps} />;
    case 'Danh mục':
    case 'Danh mục sản phẩm':
      return <ClipboardList {...iconProps} />;
    case 'Ví khách hàng':
      return <CreditCard {...iconProps} />;
    case 'Thu - Chi':
    case 'Thu nợ':
    case 'Sổ quỹ':
      return <CircleDollarSign {...iconProps} />;
    case 'Phiếu thu':
    case 'Phiếu chi':
      return <Receipt {...iconProps} />;
    default:
      return '';
  }
};

export const handleUpdateOrderNote = async ({
  id,
  type,
  value,
  dispatch,
}: {
  id: string;
  type: string;
  value: string;
  dispatch: any;
}): Promise<boolean> => {
  try {
    const params = {
      id,
      body: {
        ...(type == 'CUSTOMER'
          ? { customerNote: value }
          : { supplierNote: value }),
      },
    };
    await dispatch(updateOrderNote(params)).unwrap();

    // Notification('success', 'Cập nhật ghi chú thành công');
    return true;
  } catch (error: any) {
    Notification('error', 'Cập nhật ghi chú thất bại', error);
    return false;
  }
};

export const handleUpdateProposalItemNote = async ({
  id,
  type,
  value,
  dispatch,
  shouldNotCheckPermission,
}: {
  id: string;
  type: string;
  value: string;
  dispatch: any;
  shouldNotCheckPermission?: boolean;
}): Promise<boolean> => {
  try {
    const params = {
      id,
      body: {
        ...(type == 'CUSTOMER'
          ? { customerNote: value }
          : { supplierNote: value }),
        ...(shouldNotCheckPermission ? { shouldNotCheckPermission } : {}),
      },
    };

    const updateResult: any = await dispatch(
      updateProposalItemNote(params)
    ).unwrap();

    // Notification('success', 'Cập nhật ghi chú thành công');
    return updateResult?.data;
  } catch (error: any) {
    Notification('error', 'Cập nhật ghi chú thất bại', error);
    return false;
  }
};

export const handleUserUpdateOrderItemNote = async ({
  id,
  type,
  value,
  dispatch,
}: {
  id: string;
  type: string;
  value: string;
  dispatch: any;
}): Promise<boolean> => {
  try {
    const params = {
      id,
      body: {
        ...(type == 'CUSTOMER'
          ? { customerNote: value }
          : { supplierNote: value }),
      },
    };

    await dispatch(updateOrderItemNote(params)).unwrap();

    // Notification('success', 'Cập nhật ghi chú thành công');
    return true;
  } catch (error: any) {
    Notification('error', 'Cập nhật ghi chú thất bại', error);
    return false;
  }
};

export const handleEntityUpdateOrderItemNote = async ({
  id,
  type,
  value,
  dispatch,
}: {
  id: string;
  type: string;
  value: string;
  dispatch: any;
}): Promise<boolean> => {
  try {
    const params = {
      id,
      body: {
        ...(type == 'CUSTOMER'
          ? { customerNote: value }
          : { supplierNote: value }),
      },
    };

    await dispatch(updateOrderItemNote(params)).unwrap();

    // Notification('success', 'Cập nhật ghi chú thành công');
    return true;
  } catch (error: any) {
    Notification('error', 'Cập nhật ghi chú thất bại', error);
    return false;
  }
};

export const handleUpdateTempCustomerNote = async ({
  id,
  type,
  value,
  dispatch,
}: {
  id: string;
  type: string;
  value: string;
  dispatch: any;
}): Promise<boolean> => {
  try {
    const params = {
      supplierID: id,
      customerNote: value,
    };

    const updateResult: any = await dispatch(updateTempCustomerNote(params));

    // Notification('success', 'Cập nhật ghi chú thành công');
    return true;
  } catch (error: any) {
    Notification('error', 'Cập nhật ghi chú thất bại', error);
    return false;
  }
};
